import React, { useEffect, useRef, useState } from 'react';
import {
	AccountCircle,
	Send,
	Add,
	AttachMoney,
	Description as DescriptionIcon,
	Assignment,
	TimerOff as TimerOffIcon,
	Image as ImageIcon,
	AttachFile as AttachFileIcon,
	Mic as MicIcon,
} from '@material-ui/icons';
import {
	ChatHeader,
	ChatHeaderInfo,
	ChatMessages,
	Message,
	MessageContent,
	MessageTimestamp,
	ChatInputForm,
	ChatInput,
	SendButton,
	DateSeparator,
	ButtonSelectOperator,
	LoadMoreButton,
	LoadingMessageContainer,
	ChatEndedWrapper,
	ChatEndedMessage,
	ReopenChatButton,
	ActionButton,
	ActionDialog,
	ActionList,
	ActionItem,
	OfficialBadge,
} from './styles';
import { formatDate } from '../../utils/dateFormatters';
import { formatMessageContent } from '../../utils/messageFormatters';
import { ArrowDropDown, ChangeCircle, Verified as VerifiedIcon } from '@mui/icons-material';
import { Tooltip } from '@material-ui/core';
import { pipego } from 'api/pipego';
import Modal from 'newComponents/Modal';
import { useChatArea } from './hooks/useChatArea.hooks';
import SelectSearch from 'newComponents/SelectSearch';
import { BootstrapInput } from 'app/routes/CaseDetails/CaseCard/NegotiationTab/styles';
import { useQuery } from 'react-query';
import { useMessage } from '../../context/MessageContext';
import { ChatActions } from '../ChatActions';
import DialogComponent from 'newComponents/DialogComponent';
import { useSelector } from 'react-redux';
import { useNotifyAlert } from 'context/NotifyAlert';
import { MediaMessage } from './components/MediaMessage';
import useAudioHandler from './hooks/useAudioHandler';
import AudioRecorder from './components/AudioRecorder';
import { formatPhoneNumber } from 'util/utils';
import { CallMessage } from './components/CallMessage';
import { getWhatsappUserInfo } from 'util/isAdmin';
import { MessageStatus } from './components/MessageStatus';


const ChatArea = ( {
	useForm,
} ) => {
	const { isRecording,
		recordingTime,
		audioLevels,
		recordingTimerRef,
		mediaRecorderRef,
		startRecording,
		cancelRecording,
		formatRecordingTime,
		setIsRecording,
		setRecordingTime,
	} = useAudioHandler();
	const { messagesCursor, messages, handleSendMessage, closeChat, assignChat, getTemplates, sendTemplateMessage, isMessagesLoading, setLoadMoreController, shouldScrollToBottomRef, handleReadMessages, isRunningReadMessages, selectedChat, warningDialog, setWarningDialog, updateChat, allUsers } = useMessage();
	const userEmail = useSelector( state => state.auth.userLogin );
	const { setShowNotify } = useNotifyAlert();

	const [ loadingCloseService, setLoadingCloseService ] = useState( false );
	const [ loadingAssignChat, setLoadingAssignChat ] = useState( false );
	const [ openDialog, setOpenDialog ] = useState( false );
	const [ chatIdInput, setChatIdInput ] = useState( '' );
	const { profileType, userId, handleOpenModal, handleCloseModal, visible, handleFetchOperators, handleUpdateOperator } = useChatArea();

	const [ openActionDialog, setOpenActionDialog ] = useState( false );
	const actionButtonRef = useRef( null );
	const [ actionDialogPosition, setActionDialogPosition ] = useState( { top: 0, left: 0 } );
	const textareaRef = useRef( null );
	const imageInputRef = useRef( null );
	const documentInputRef = useRef( null );
	const chatRef = useRef( null );
	const isInitialLoad = useRef( true );

	const isCaseAssigned = !!selectedChat?.caseId;
	const isConversationEnded = selectedChat?.status === 'Finalizado';

	const userPermittedToAssignChat = !selectedChat?.userId ? false : [ 1, 2 ].includes( profileType ) ? false : true;

	const hasCaseId = !!selectedChat?.caseId;

	const [ selectedImage, setSelectedImage ] = useState( null );
	const [ imagePreview, setImagePreview ] = useState( null );
	const [ selectedDocument, setSelectedDocument ] = useState( null );
	const isDefaultTemplate = useRef( false );

	// Estado temporário para armazenar o operador selecionado
	const [ tempSelectedOperator, setTempSelectedOperator ] = useState( null );

	const messageValue = useForm.watch( 'message' );

	// Estado para modal de imagem fullscreen
	const [ fullscreenImage, setFullscreenImage ] = useState( null );

	const [ openAdminDialog, setOpenAdminDialog ] = useState( false );
	const [ openSubSessionDialog, setOpenSubSessionDialog ] = useState( false );

	const validateUserPermission = () => {
		if ( profileType === 1 && selectedChat.userEmail !== userEmail ) {
			return false;
		}

		else if ( profileType !== 1 && selectedChat.userEmail === userEmail ) {
			return false;
		}

		else if ( selectedChat.userEmail === userEmail ) {
			return false;
		}

		else if ( !selectedChat.userId  ) {
			return false;
		}

		return true;
	};

	const isUserBlockedToSendMessage = validateUserPermission();
	const isAudioDisabled = selectedChat.userId !== userId || isConversationEnded;
	const isActionButtonEnabled = !isUserBlockedToSendMessage && hasCaseId;

	const resizeTextarea = () => {
		const textarea = textareaRef.current;
		if ( textarea ) {
			textarea.style.height = 'auto'; // Reset height
			textarea.style.height = `${Math.min( textarea.scrollHeight, 300 )}px`;
		}
	};

	const handleChange = ( e ) => {
		useForm.setValue( 'message', e.target.value );
	};

	const { data: operators } = useQuery( {
		queryKey : [ 'operators' ],
		queryFn  : () => handleFetchOperators()
	} );

	const groupMessagesByDate = ( messages ) => {
		const groups = {};
		messages.forEach( message => {
			const date = new Date( message.createdAt ).toDateString();
			if ( !groups[date] ) {
				groups[date] = [];
			}
			groups[date].push( message );
		} );
		return groups;
	};

	const groupedMessages = groupMessagesByDate( messages );
	const messageDates = Object.keys( groupedMessages );

	const handleOpenAssignDialog = () => {
		setOpenDialog( ( prev ) => !prev );
	};

	const handleOpenActionDialog = () => {
		if ( openActionDialog ) {
			handleCloseActionDialog();
			return;
		}

		if ( actionButtonRef.current ) {
			const buttonRect = actionButtonRef.current.getBoundingClientRect();
			setActionDialogPosition( {
				top  : buttonRect.top + window.scrollY - 300,
				left : buttonRect.left + window.scrollX
			} );
		}
		setOpenActionDialog( true );
	};

	const handleCloseActionDialog = () => {
		setOpenActionDialog( false );
	};

	const handleLoadMessages = async () => {
		setLoadMoreController( ( prev ) => !prev );
	};

	const convertToBase64 = ( file ) => {
		return new Promise( ( resolve, reject ) => {
			const reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = () => {
				const [ meta, base64String ] = reader.result.split( ',' );
				const mimetype = meta.match( /data:(.*);base64/ )[1];
				resolve( { mimetype, base64String } );
			};
			reader.onerror = ( error ) => reject( error );
		} );
	};

	const handleImageUpload = async ( event ) => {
		const file = event.target.files[0];
		if ( file ) {
			if ( !file.type.startsWith( 'image/' ) ) {
				setShowNotify( {
					status : 'error',
					text   : 'Por favor, selecione apenas arquivos de imagem.'
				} );
				return;
			}

			try {
				const { mimetype, base64String } = await convertToBase64( file );
				setSelectedImage( { base64String, mimetype } );
				setImagePreview( URL.createObjectURL( file ) );
				handleCloseActionDialog();
			} catch ( error ) {
				console.error( 'Erro ao converter imagem:', error );
				setShowNotify( {
					status : 'error',
					text   : 'Erro ao processar a imagem.'
				} );
			}
		}
	};

	const handleRemoveMedia = () => {
		setSelectedImage( null );
		setImagePreview( null );
		setSelectedDocument( null );
	};

	const handleDocumentUpload = async ( event ) => {
		const file = event.target.files[0];
		if ( file ) {
			const allowedTypes = [
				'application/pdf',
				'application/msword',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/vnd.ms-excel',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			];

			if ( !allowedTypes.includes( file.type ) ) {
				setShowNotify( {
					status : 'error',
					text   : 'Por favor, selecione apenas arquivos do tipo PDF, Word ou Excel.'
				} );
				return;
			}

			try {
				const { mimetype, base64String } = await convertToBase64( file );
				setSelectedDocument( {
					base64   : base64String,
					fileName : file.name,
					type     : file.type,
					mimetype,
				} );
				handleCloseActionDialog();
			} catch ( error ) {
				console.error( 'Erro ao converter documento:', error );
				setShowNotify( {
					status : 'error',
					text   : 'Erro ao processar o documento.'
				} );
			}
		}
	};

	const intermediateMessageSend = async () => {
		if ( profileType === 1 && selectedChat.userEmail !== userEmail ) {
			setOpenAdminDialog( true );
			return;
		}
		handleSendMessageWithScroll();
	};

	// Função para limpar texto para comparação
	const cleanTextForComparison = (text) => {
		if (!text) return '';
		return text
			.toLowerCase()
			.replace(/[\s\n\r\t]+/g, ' ') // Substitui múltiplos espaços/quebras por um espaço
			.replace(/[^\w\s]/g, '') // Remove pontuação
			.trim(); // Remove espaços do início e fim
	};

	const handleSendMessageWithScroll = async () => {
    let fromTemplate = false;
		if ( selectedChat.userId !== userId ) {
			await assignChat( selectedChat?.id, userId, userEmail );
		}

		if ( isDefaultTemplate.current ) {
			// Comparação mais robusta
			const templateText = cleanTextForComparison(isDefaultTemplate.current);
			const messageText = cleanTextForComparison(useForm.watch('message'));

			if (templateText === messageText) {
				fromTemplate = true;
			}
		}

		if ( selectedImage ) {
			const messageData = {
				mediaType  : 'image',
				message    : useForm.watch( 'message' ),
				content    : selectedImage.base64String,
				mimetype   : selectedImage.mimetype,
				storageUrl : imagePreview,
				createdAt  : new Date().toISOString(),
				status     : 'pending'
			};

			handleSendMessage( messageData, useForm, userEmail );
			handleRemoveMedia();
		} else if ( selectedDocument ) {
			const messageData = {
				message   : useForm.watch( 'message' ),
				mediaType : 'document',
				fileName  : selectedDocument.fileName,
				content   : selectedDocument.base64,
				mimetype  : selectedDocument.mimetype,
				createdAt : new Date().toISOString(),
				status    : 'pending'
			};

			handleSendMessage( messageData, useForm, userEmail );
			handleRemoveMedia();
		} else {
			const messageData = {
				message   : useForm.watch( 'message' ),
				mediaType : 'text',
				createdAt : new Date().toISOString(),
				status    : 'pending',
        fromTemplate
			};
			await handleSendMessage( messageData, useForm, userEmail );
		}
	};

	const handleAssignChat = async () => {
		try {
			setLoadingAssignChat( true );
			await assignChat( selectedChat?.id, userId, userEmail, chatIdInput );
			handleOpenAssignDialog();
			setChatIdInput( '' );
		} finally {
			setLoadingAssignChat( false );
		}
	};

	const handleCloseService = async () => {
		if ( selectedChat?.userEmail !== userEmail ) {
			setShowNotify( {
				status : 'error',
				text   : 'Apenas o responsável pelo chat pode finalizá-lo.'
			} );
			return;
		}

		setLoadingCloseService( true );
		await closeChat( selectedChat?.id );
		setLoadingCloseService( false );
	};

	const handleKeyDown = ( e ) => {
		if ( e.key === 'Enter' && !e.shiftKey ) {
			e.preventDefault();
			useForm.handleSubmit( intermediateMessageSend )( e );
		}
	};

	const handleSetMessage = ( message ) => {
    isDefaultTemplate.current = message;
		useForm.setValue( 'message', message );
	};

	useEffect( () => {
		resizeTextarea();
	}, [ messageValue ] );

	useEffect( () => {
		isInitialLoad.current = true;
		const templateIds = getWhatsappUserInfo()?.sessionId === 'session-3' ?
		 [ 1, 2, 3, 4, 5, 6, 7] : [ 1, 2, 3, 4, 5 ];
		if ( selectedChat && selectedChat?.caseId ) {
			getTemplates( {
				caseId      : parseInt( selectedChat.caseId?.replace( /\D/g, '' ) ),
				templateIds : templateIds,
				contactName : selectedChat?.name
			} );
		}
	}, [ selectedChat ] ); //eslint-disable-line

	useEffect( () => {
		if ( !chatRef.current || !selectedChat || messages.length === 0 ) return;

		if ( shouldScrollToBottomRef.current ) {
			requestAnimationFrame( () => {
				chatRef.current.scrollTop = chatRef.current.scrollHeight;
			} );
			shouldScrollToBottomRef.current = false;
			return;
		}

		// Nova mensagem chegou via polling — só rola se já estiver perto do fundo
		const { scrollTop, scrollHeight, clientHeight } = chatRef.current;
		const isNearBottom = scrollHeight - scrollTop - clientHeight < 150;
		if ( isNearBottom ) {
			requestAnimationFrame( () => {
				chatRef.current.scrollTop = chatRef.current.scrollHeight;
			} );
		}
	}, [ selectedChat, messages.length ] ); //eslint-disable-line

	useEffect( () => {
		const handleClickOutside = ( event ) => {
			if ( openActionDialog ) {
				const dialogElement = document.querySelector( '.action-dialog' );
				if ( dialogElement && !dialogElement.contains( event.target ) &&
					actionButtonRef.current && !actionButtonRef.current.contains( event.target ) ) {
					handleCloseActionDialog();
				}
			}
		};

		document.addEventListener( 'mousedown', handleClickOutside );
		return () => {
			document.removeEventListener( 'mousedown', handleClickOutside );
		};
	}, [ openActionDialog ] );

	const handleImageClick = async ( imgUrl ) => {
		setFullscreenImage( imgUrl );
	};

	const handleCloseImageModal = () => {
		setFullscreenImage( null );
	};

	const handleConfirmOperatorChange = () => {
		if ( tempSelectedOperator ) {
			const selectedOperator = operators.find( operator => operator.id === tempSelectedOperator );
			handleUpdateOperator( selectedChat.id, tempSelectedOperator, selectedOperator?.email );
		}
		handleCloseModal();
	};

	const handleCloseModalWithReset = () => {
		setTempSelectedOperator( null );
		handleCloseModal();
	};

	const handleRefreshSubSession = async () => {
		try {
			await pipego.refreshSubSession( selectedChat.id );
			setShowNotify( { status: 'success', text: 'Telefone de atendimento atualizado' } );
		} catch ( e ) {
			setShowNotify( { status: 'error', text: e?.response?.data?.error || 'Erro ao atualizar telefone de atendimento' } );
		} finally {
			setOpenSubSessionDialog( false );
		}
	};

	let cooldownTimeout = null;

	const handleScroll = () => {
		if ( !isRunningReadMessages && !cooldownTimeout ) {
			handleReadMessages( selectedChat );
			cooldownTimeout = setTimeout( () => {
				cooldownTimeout = null;
			}, 1000 );
		}
	};

	useEffect( () => {
		const chatElement = chatRef.current;
		if ( !chatElement ) return;

		chatElement.addEventListener( 'scroll', handleScroll );

		return () => {
			chatElement.removeEventListener( 'scroll', handleScroll );
		};
	}, [ selectedChat, handleReadMessages ] ); //eslint-disable-line

	useEffect( () => {
		const chatElement = chatRef.current;
		if ( !chatElement ) return;

		const handleUserInteraction = () => {
			if ( !isRunningReadMessages && !cooldownTimeout ) {
				handleReadMessages( selectedChat );
				cooldownTimeout = setTimeout( () => {
					cooldownTimeout = null;
				}, 1000 );
			}
		};

		chatElement.addEventListener( 'scroll', handleUserInteraction );
		chatElement.addEventListener( 'mousemove', handleUserInteraction );
		chatElement.addEventListener( 'keydown', handleUserInteraction );

		return () => {
			chatElement.removeEventListener( 'scroll', handleUserInteraction );
			chatElement.removeEventListener( 'mousemove', handleUserInteraction );
			chatElement.removeEventListener( 'keydown', handleUserInteraction );
		};
	}, [ selectedChat, handleReadMessages ] );

	return (
		<div style={{
			width         : '100%',
			height        : '100%',
			display       : 'flex',
			flexDirection : 'column',
			boxSizing     : 'border-box'
		}}>
			<input
				type="file"
				ref={imageInputRef}
				style={{ display: 'none' }}
				accept="image/*"
				onClick={( e ) => { e.target.value = ''; }}
				onChange={handleImageUpload}
			/>
			<input
				type="file"
				ref={documentInputRef}
				style={{ display: 'none' }}
				accept=".pdf,.doc,.docx,.xls,.xlsx"
				onClick={( e ) => { e.target.value = ''; }}
				onChange={handleDocumentUpload}
			/>
			<ChatHeader>
				<ChatHeaderInfo>
					{selectedChat ? (
						<>
								{selectedChat.profilePicUrl ? (
									<img
									src={selectedChat.profilePicUrl}
									alt="Contact"
									width={32}
									height={32}
									className="w-full h-full rounded-circle"
									/>
								) : (
									<AccountCircle className="w-16 h-16 text-zinc-400" />
								)}

								<div className="flex flex-col gap-2">
									<h3 className="text-white" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
										{selectedChat.name ? `${selectedChat.name} - ${formatPhoneNumber(selectedChat?.id?.split( '@' )[0])}` : formatPhoneNumber(selectedChat?.id?.split( '@' )[0])}
										{selectedChat?.source === 'oficial' && (
											<Tooltip title="Conversa através do número oficial">
												<VerifiedIcon style={{ fontSize: '18px', color: '#25D366' }} />
											</Tooltip>
										)}
									</h3>
									<p className="text-gray-300">{selectedChat.number}</p>

									<div className="flex flex-row">
										<p className="d-flex flex-row align-items-center text-gray-300 text-sm">Atendido por:
											<ButtonSelectOperator className='ml-2' onClick={handleOpenModal}>
												{selectedChat?.source === 'oficial'
													? ( () => {
														// Mesmo formato do bailey quando o backend manda nome e departamento.
														if ( selectedChat?.userName ) {
															return selectedChat?.departmentName ? `${selectedChat.userName} - ${selectedChat.departmentName}` : selectedChat.userName;
														}
														const op = allUsers?.find( u => Number( u.acordoFechadoId ) === Number( selectedChat?.userId ) );
														return op ? op.name : ( selectedChat?.userEmail ?? 'Nenhum responsável' );
													} )()
													: selectedChat?.userName
														? `${selectedChat?.userName} - ${selectedChat?.departmentName}`
														: 'Nenhum responsável'
												}
												<ArrowDropDown />
											</ButtonSelectOperator>
										</p>
										<p className="d-flex flex-row align-items-center text-gray-300 text-sm">
									{selectedChat?.source === 'oficial'
										? `Telefone utilizado no atendimento: ${selectedChat?.officialPhoneNumber ?? '-'}`
										: <>
											Telefone utilizado no atendimento: {formatPhoneNumber(selectedChat?.phoneNumber)}
											<ChangeCircle
												style={{ fontSize: '18px', cursor: 'pointer', marginLeft: '6px' }}
												title="Trocar o telefone de atendimento"
												onClick={() => setOpenSubSessionDialog( true )}
											/>
										</>
									}
								</p>
									</div>
								</div>
							</>

					) : (
						<div className="flex flex-col gap-2">
							<h3 className="text-white">Não atribuído</h3>
						</div>
					)}
				</ChatHeaderInfo>
			</ChatHeader>
			<ChatActions
				loadingCloseService={loadingCloseService}
				isCaseAssigned={isCaseAssigned}
				isConversationEnded={isConversationEnded}
				onEndConversation={handleCloseService}
				onAssignCase={handleOpenAssignDialog}
				caseId={selectedChat?.caseId}
			/>

			{/* Dialog de atribuição de caso */}
			<DialogComponent
				confirmation={openDialog}
				title={'Insira o id do caso'}
				subText={'Digite um id de pelo menos 7 dígitos para vincular ao chat.'}
				closeFunction={handleOpenAssignDialog}
				callback={handleAssignChat}
				loading={loadingAssignChat}
				disabled={loadingAssignChat}
			>
				<input
					className="h-10 w-full rounded-md border border-gray-200 bg-white px-3 py-2 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-400"
					placeholder={'Digite o id do caso aqui'}
					value={chatIdInput}
					onChange={( e ) => setChatIdInput( e.target.value )}
					disabled={loadingAssignChat}
				/>
			</DialogComponent>

			<ChatMessages ref={chatRef} isEnded={isConversationEnded}>
				{!isMessagesLoading && messagesCursor && (
					<LoadMoreButton type='button' onClick={handleLoadMessages}>
						Carregar Mais
					</LoadMoreButton>
				)}

				{
					isMessagesLoading && (
						<LoadingMessageContainer>
							<MessageTimestamp>Carregando mensagens...</MessageTimestamp>
						</LoadingMessageContainer>
					)
				}
				{
					messageDates.map( ( date ) => (
						<React.Fragment key={date}>
							<DateSeparator>
								{formatDate( groupedMessages[date][0].createdAt )}
							</DateSeparator>
							{groupedMessages[date].map( ( message ) => (
								<Message key={message.id} sender={message.type}>
									<MessageContent sender={message.type} style={{ position: 'relative' }}>
										{message.userEmail && (
											<div style={{
												fontSize     : '11px',
												color        : '#444b54',
												marginBottom : 2,
												fontWeight   : 600
											}}>
												{message.userEmail}
											</div>
										)}
										<div className='flex flex-col gap-2'>
											{message.mediaType === 'image' || message.mediaType === 'document' || message.mediaType === 'audio' || message.mediaType === 'sticker' ? (
												<MediaMessage
													mediaType={message.mediaType}
													storageUrl={message.storageUrl}
													fileName={message.fileName}
													mimetype={message.mimetype}
													content={message.content}
													mediaContent={message.mediaContent}
													sender={message.type}
													duration={message.duration}
													onImageClick={handleImageClick}
												/>
											) : message.mediaType === 'call' ? <CallMessage message={message} /> : (
												<p style={{ whiteSpace: 'pre-wrap' }}>
													{formatMessageContent( message.content )}
												</p>
											)}
										</div>
										{message.reactionEmoji && (
											<div style={{
												position     : 'absolute',
												bottom       : '-10px',
												right        : message.type === 'sent' ? '6px' : 'auto',
												left         : message.type === 'received' ? '6px' : 'auto',
												background   : '#fff',
												borderRadius : '10px',
												padding      : '1px 5px',
												fontSize     : '14px',
												boxShadow    : '0 1px 3px rgba(0,0,0,0.2)',
												lineHeight   : '18px',
												zIndex       : 1,
											}}>
												{message.reactionEmoji}
											</div>
										)}
										<MessageTimestamp>
											{new Date( message.createdAt ).toLocaleTimeString( [], {
												hour     : '2-digit',
												minute   : '2-digit',
												hour12   : false,
												timeZone : 'UTC'
											} )}
											{message.type === 'sent' && <MessageStatus status={message.status} errorMessage={message.errorMessage} />}
										</MessageTimestamp>
									</MessageContent>
								</Message>
							) )}
						</React.Fragment>
					) )}

				{isConversationEnded && (
					<Message key='ended-message'>
						<ChatEndedWrapper>
							<ChatEndedMessage>
								<p>Esta conversa foi finalizada</p>
							</ChatEndedMessage>
							<ReopenChatButton onClick={() => updateChat({ ...selectedChat, status: 'Em aberto', negotiatorId: userId })}>
								Reabrir conversa
							</ReopenChatButton>
						</ChatEndedWrapper>
					</Message>
				)
				}
			</ChatMessages>

			<div style={{
				padding       : '8px 16px',
				borderTop     : '1px solid rgba(134, 150, 160, 0.15)',
				background    : '#f0f2f5',
				display       : 'flex',
				flexDirection : 'column',
				gap           : '8px',
				minHeight     : '89px',
			}}>
				{/* Preview de Mídia */}
				{( imagePreview || selectedDocument ) && (
					<div style={{
						display      : 'flex',
						alignItems   : 'center',
						gap          : '8px',
						padding      : '8px',
						background   : '#f0f2f5',
						borderRadius : '8px',
						position     : 'relative',
						maxWidth     : '100%',
						overflow     : 'hidden'
					}}>
						{imagePreview && (
							<div style={{
								width        : '100px',
								height       : '100px',
								borderRadius : '4px',
								overflow     : 'hidden',
								position     : 'relative',
								flexShrink   : 0
							}}>
								<img
									src={imagePreview}
									alt="Preview"
									style={{
										width     : '100%',
										height    : '100%',
										objectFit : 'cover',
										cursor    : 'pointer'
									}}
									onClick={() => handleImageClick( imagePreview )}
								/>
							</div>
						)}
						{selectedDocument && (
							<div style={{
								display      : 'flex',
								alignItems   : 'center',
								gap          : '8px',
								background   : 'rgba(134, 150, 160, 0.15)',
								padding      : '8px 12px',
								borderRadius : '8px',
								width        : '100%',
								minWidth     : 0
							}}>
								<DescriptionIcon style={{ color: '#8696a0', flexShrink: 0 }} />
								<span style={{
									overflow     : 'hidden',
									whiteSpace   : 'nowrap',
									textOverflow : 'ellipsis',
									flex         : 1
								}}>
									{selectedDocument.fileName}
								</span>
							</div>
						)}
						<button
							onClick={handleRemoveMedia}
							style={{
								position        : 'absolute',
								top             : '4px',
								right           : '4px',
								backgroundColor : 'rgba(0, 0, 0, 0.5)',
								color           : 'white',
								border          : 'none',
								borderRadius    : '50%',
								width           : '20px',
								height          : '20px',
								display         : 'flex',
								alignItems      : 'center',
								justifyContent  : 'center',
								cursor          : 'pointer',
								fontSize        : '14px',
								padding         : '0'
							}}
						>
							×
						</button>
					</div>
				)}

				{isRecording ? (
					<AudioRecorder
						isAudioDisabled={isAudioDisabled}
						handleSendMessage={handleSendMessage}
						mediaRecorderRef={mediaRecorderRef}
						isRecording={isRecording}
						recordingTimerRef={recordingTimerRef}
						setIsRecording={setIsRecording}
						recordingTime={recordingTime}
						setRecordingTime={setRecordingTime}
						audioLevels={audioLevels}
						cancelRecording={cancelRecording}
						formatRecordingTime={formatRecordingTime}
						useForm={useForm}
					/>
				) : (
					<ChatInputForm onSubmit={useForm.handleSubmit( intermediateMessageSend )}>
						<ActionButton
							ref={actionButtonRef}
							onClick={handleOpenActionDialog}
							disabled={!isActionButtonEnabled}
							type='button'
							title={!isActionButtonEnabled ? 'Você precisa ser o responsável pelo chat e ter um caso vinculado para usar esta função' : ''}
						>
							<Add fontSize="small" />
						</ActionButton>
						<ChatInput
							ref={textareaRef}
							rows={1}
							disabled={isUserBlockedToSendMessage || isConversationEnded}
							type="text"
							placeholder={selectedImage ? 'Adicione uma legenda...' : selectedDocument ? 'Adicione uma descrição...' : 'Escreva sua mensagem...'}
							value={messageValue}
							onChange={handleChange}
							onKeyDown={handleKeyDown}
							style={{ maxHeight: '150px', overflowY: 'auto' }}
						/>
						<button
							type="button"
							onClick={startRecording}
							disabled={isUserBlockedToSendMessage || isConversationEnded}
							style={{
								background     : 'none',
								border         : 'none',
								cursor         : isUserBlockedToSendMessage ? 'not-allowed' : 'pointer',
								padding        : '8px',
								display        : 'flex',
								alignItems     : 'center',
								justifyContent : 'center',
								color          : '#8696a0'
							}}
						>
							<MicIcon />
						</button>
						<SendButton
							type="submit"
							disabled={isUserBlockedToSendMessage || isConversationEnded}
						>
							<Send fontSize='small' className="text-white" />
						</SendButton>
					</ChatInputForm>
				)}
			</div>

			{/* Dialog de ações */}
			{openActionDialog && (
				<ActionDialog
					className="action-dialog"
					style={{
						top       : `${actionDialogPosition.top}px`,
						left      : `${actionDialogPosition.left}px`,
						transform : 'none'
					}}
				>
					<ActionList>
						<ActionItem onClick={() => sendTemplateMessage( 'interesse', handleSetMessage )}>
							<DescriptionIcon fontSize="small" style={{ marginRight: '12px' }} />
							Enviar mensagem de interesse
						</ActionItem>
						<ActionItem onClick={() => sendTemplateMessage( 'proposta', handleSetMessage )}>
							<Assignment fontSize="small" style={{ marginRight: '12px' }} />
							Enviar mensagem de proposta
						</ActionItem>
						{getWhatsappUserInfo()?.sessionId === 'session-3' && <ActionItem onClick={() => sendTemplateMessage( 'interesse Dombroski', handleSetMessage )}>
							<DescriptionIcon fontSize="small" style={{ marginRight: '12px' }} />
							Enviar mensagem de interesse - Dombroski
						</ActionItem>}
						{getWhatsappUserInfo()?.sessionId === 'session-3' && <ActionItem onClick={() => sendTemplateMessage( 'proposta Dombroski', handleSetMessage )}>
							<Assignment fontSize="small" style={{ marginRight: '12px' }} />
							Enviar mensagem de proposta - Dombroski
						</ActionItem>}
						<ActionItem onClick={() => sendTemplateMessage( 'cobrança de minuta', handleSetMessage )}>
							<AttachMoney fontSize="small" style={{ marginRight: '12px' }} />
							Enviar cobrança de minuta
						</ActionItem>
						<ActionItem onClick={() => sendTemplateMessage( 'ausência de resposta', handleSetMessage )}>
							<TimerOffIcon fontSize="small" style={{ marginRight: '12px' }} />
							Ausência de resposta
						</ActionItem>
						<ActionItem onClick={() => imageInputRef.current?.click()}>
							<ImageIcon fontSize="small" style={{ marginRight: '12px' }} />
							Enviar imagem
						</ActionItem>
						<ActionItem onClick={() => documentInputRef.current?.click()}>
							<AttachFileIcon fontSize="small" style={{ marginRight: '12px' }} />
							Enviar documentos
						</ActionItem>
					</ActionList>
				</ActionDialog>
			)}

			{/* Modal para selecionar o responsável */}
			<Modal visible={visible} onClose={handleCloseModalWithReset}>
				<div style={{ width: '500px', minWidth: '90%' }}>
					<h6>Selecione o responsável</h6>
					<SelectSearch
						variant={'outlined'}
						fullWidth
						disabled={ userPermittedToAssignChat || isConversationEnded }
						size='small'
						options={operators?.map( operator => ( { label: `${operator.name} - ${operator.departmentName}`, value: operator.id } ) ) ?? []}
						selectedState={tempSelectedOperator || selectedChat.userId}
						setSelectedState={setTempSelectedOperator}
						input={<BootstrapInput />}
					/>
				</div>

				<div className='d-flex mt-3 justify-content-between' style={{ gap: '12px' }}>
					<button onClick={handleCloseModalWithReset} style={{ padding: '10px 20px', background: '#f0f0f0', border: 'none', borderRadius: '4px' }}>Cancelar</button>
					<button onClick={handleConfirmOperatorChange} style={{ padding: '10px 20px', background: '#00A884', color: 'white', border: 'none', borderRadius: '4px' }}>Confirmar</button>
				</div>
			</Modal>

			{/* Modal de imagem fullscreen */}
			<Modal visible={!!fullscreenImage} onClose={handleCloseImageModal}>
				{fullscreenImage && (
					<div style={{
						position       : 'fixed',
						top            : 0,
						left           : 0,
						width          : '100vw',
						height         : '100vh',
						background     : 'rgba(0,0,0,0.05)',
						display        : 'flex',
						alignItems     : 'center',
						justifyContent : 'center',
						zIndex         : 9999
					}}>
						<img
							src={fullscreenImage}
							alt="Imagem em fullscreen"
							style={{
								maxWidth     : '60vw',
								maxHeight    : '70vh',
								objectFit    : 'contain',
								borderRadius : '12px',
								boxShadow    : '0 2px 16px rgba(0,0,0,0.1)'
							}}
						/>
						<button
							onClick={handleCloseImageModal}
							style={{
								position       : 'absolute',
								top            : 64,
								right          : 24,
								color          : '#a8a5a5',
								border         : 'none',
								background     : 'rgba(0,0,0,0.0)',
								width          : 70,
								height         : 60,
								display        : 'flex',
								alignItems     : 'center',
								justifyContent : 'center',
								cursor         : 'pointer',
								fontSize       : 32,
								zIndex         : 9999
							}}
						>
							×
						</button>
					</div>
				)}
			</Modal>

			<DialogComponent
				confirmation={warningDialog?.open}
				title={warningDialog.title}
				subText={warningDialog.subText}
				closeFunction={() => setWarningDialog( { ...warningDialog, open: false } )}
				callback={() => {
					setWarningDialog( false );
				}}
			/>

			<DialogComponent
				confirmation={openAdminDialog}
				title="Deseja se tornar o responsável por esta conversa?"
				subText="Ao confirmar, você será o responsável por esta conversa, e a mensagem será enviada."
				closeFunction={() => setOpenAdminDialog( false )}
				callback={() => {
					handleSendMessageWithScroll();
					setOpenAdminDialog( false );
				}}
			/>

			<DialogComponent
				confirmation={openSubSessionDialog}
				title="Trocar telefone de atendimento?"
				subText="Ao confirmar, um novo número de telefone será atribuído a este atendimento."
				closeFunction={() => setOpenSubSessionDialog( false )}
				callback={handleRefreshSubSession}
			/>
		</div>
	);
};

export { ChatArea };
